import { render, staticRenderFns } from "./highlights-dist.vue?vue&type=template&id=1de8bc26&scoped=true&"
import script from "./highlights-dist.vue?vue&type=script&lang=js&"
export * from "./highlights-dist.vue?vue&type=script&lang=js&"
import style0 from "./highlights-dist.vue?vue&type=style&index=0&id=1de8bc26&scoped=true&lang=css&"
import style1 from "./highlights-dist.vue?vue&type=style&index=1&id=1de8bc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8bc26",
  null
  
)

export default component.exports